/**
 * Offcanvas Menu Handler
 * Handles collapsible sections in the mobile offcanvas menu
 * Prevents swipe-to-close gestures
 * Hides topbar when menu is open
 */

import { Collapse, Offcanvas } from 'bootstrap';

document.addEventListener('DOMContentLoaded', function() {
  const offcanvasElement = document.getElementById('navbarOffcanvas');
  const topbar = document.querySelector('.topbar');

  if (!offcanvasElement) return;

  // Hide topbar when offcanvas opens
  offcanvasElement.addEventListener('show.bs.offcanvas', function() {
    if (topbar) {
      topbar.style.display = 'none';
    }
  });

  // Show topbar when offcanvas closes
  offcanvasElement.addEventListener('hidden.bs.offcanvas', function() {
    if (topbar) {
      topbar.style.display = '';
    }
  });

  // Prevent touch gestures from closing the offcanvas
  offcanvasElement.addEventListener('touchstart', function(e) {
    // Allow scrolling within the offcanvas body
    if (e.target.closest('.offcanvas-body')) {
      return;
    }
    // Prevent other touch interactions that might trigger swipe-to-close
    e.stopPropagation();
  }, { passive: true });

  // Disable double-tap zoom on the offcanvas
  let lastTouchEnd = 0;
  offcanvasElement.addEventListener('touchend', function(e) {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  }, false);

  // Manually handle collapse toggle
  const collapseToggles = offcanvasElement.querySelectorAll('[data-bs-toggle="collapse"]');

  collapseToggles.forEach((toggle) => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const targetSelector = toggle.getAttribute('data-bs-target') || toggle.getAttribute('href');
      const targetElement = document.querySelector(targetSelector);

      if (!targetElement) {
        return;
      }

      // Get or create collapse instance
      let collapseInstance = Collapse.getInstance(targetElement);

      if (!collapseInstance) {
        collapseInstance = new Collapse(targetElement, {
          toggle: false
        });
      }

      // Check if transitioning - if so, wait for it to complete then toggle
      if (collapseInstance._isTransitioning) {
        // Wait for either shown or hidden event (whichever fires first)
        const toggleAfterTransition = () => {
          collapseInstance.toggle();
        };

        // Use { once: true } to automatically remove the listener after it fires
        targetElement.addEventListener('shown.bs.collapse', toggleAfterTransition, { once: true });
        targetElement.addEventListener('hidden.bs.collapse', toggleAfterTransition, { once: true });
      } else {
        collapseInstance.toggle();
      }
    });
  });

  // Close offcanvas when a link is clicked (except collapse toggles)
  const navLinks = offcanvasElement.querySelectorAll('.nav-link:not([data-bs-toggle="collapse"]):not(button)');

  navLinks.forEach(link => {
    link.addEventListener('click', function() {
      const bsOffcanvas = Offcanvas.getInstance(offcanvasElement);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    });
  });
});

